import classes from './Backdrop.module.css';

const Backdrop = () => {
    return <div className={classes.backdrop}></div>;
};

export default Backdrop;
